import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import { Form, ErrorMessage, Field, Formik } from "lib/formik"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { addIngredientSchema } from "components/Common/validation"
import {
  addIngredient,
  getIngredientDetails,
  updateIngredient,
} from "store/actions/ingredientAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import {
  getImagePreviewSrc,
  handleFileChange2,
} from "components/Shared/fileHandlers"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import TranslatedFileInput from "components/Shared/TranslatedFileInput"

const initialValues = {
  name: "",
  nameAr: "",
  displayOrder: "",
  imageUrl: "",
  imageType: "UPLOAD",
  status: true,
  imageFile: "",
  price: "",
}

const AddIngredient = ({ mode }) => {
  const { t } = useTranslation()

  document.title = `${
    mode === "add" ? t("Add") : t("Edit")
  } {t("Ingredient ")}`

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, isLoading, ingredientDetails } = useSelector(
    state => state.Ingredients
  )

  const [formValues, setFormValues] = useState(initialValues)
  const { isImageCompressing } = useSelector(state => state.Common)

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      23,
      "ingredient_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      23,
      "ingredient_3",
      accountType
    )
    if (mode === "add") {
      if (!isPermissionCreate) {
        navigate("/dashboard")
      }
    } else if (mode === "edit") {
      if (!isPermissionEdit) {
        navigate("/dashboard")
      }
    }
  }, [])

  // IF HAVE MODE===EDIT THEN UPDATE INITAIL VALUES
  useEffect(() => {
    if (mode === "edit") {
      getOldValues()
    }
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getIngredientDetails(payload))
  }

  // GET OLD VALUES WHEN HAVE
  useEffect(() => {
    if (ingredientDetails && !loading && mode === "edit") {
      const {
        _id,
        name,
        nameAr,
        price,
        displayOrder,
        imageUrlType,
        imageUrl,
        status,
      } = ingredientDetails

      setFormValues({
        ...formValues,
        name,
        nameAr,
        price,
        displayOrder,
        imageType: imageUrlType,
        imageUrl,
        status: status === 1 ? "true" : false,
      })
    }
  }, [ingredientDetails])

  const handleOnSubmit = values => {
    const {
      name,
      nameAr,
      displayOrder,
      imageUrl,
      imageType,
      status,
      imageFile,
      price,
    } = values

    let data = new FormData()
    data.append("name", name)
    data.append("nameAr", nameAr)
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", status ? 1 : 0) //HIDE FOR NOW
    data.append("image", imageFile)
    data.append("price", price)

    if (mode === "add") {
      dispatch(addIngredient(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(`/ingredients`)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "edit") {
      data.append("id", id)
      dispatch(updateIngredient(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(`/ingredients`)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  if (mode === "edit" && loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-2 d-flex align-items-center">
                  <BackButton />
                  {mode === "add" ? t("Add") : t("Edit")} {t("Ingredient")}
                </CardTitle>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={addIngredientSchema(mode)}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, setFieldValue, errors, touched }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(English)")}
                            </label>
                            <Field
                              type="text"
                              id="name"
                              name="name"
                              placeholder={t("Name(English)")}
                              className={`form-control ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            />
                            <TextError name="name" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(عربي)")}
                            </label>
                            <Field
                              type="text"
                              id="nameAr"
                              name="nameAr"
                              placeholder={t("Name(عربي)")}
                              className={`form-control ${
                                touched.nameAr && errors.nameAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                              style={{ direction: "rtl" }}
                            />
                            <TextError name="nameAr" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="displayOrder">
                              <span className="text-danger">*</span>{" "}
                              {t("Display Order")}
                            </label>
                            <Field
                              type="text"
                              id="displayOrder"
                              name="displayOrder"
                              placeholder={t("Display Order")}
                              className={`form-control ${
                                touched.displayOrder && errors.displayOrder
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="displayOrder" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="price">
                              <span className="text-danger">*</span>{" "}
                              {t("Price")}
                            </label>
                            <Field
                              type="text"
                              id="price"
                              name="price"
                              placeholder={t("Price")}
                              className={`form-control ${
                                touched.price && errors.price
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="price" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="imageType">{t("Image Type")}</label>
                            <Field
                              as="select"
                              id="imageType"
                              name="imageType"
                              className={`form-control ${
                                touched.imageType && errors.imageType
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={e => {
                                const selectedValue = e.target.value
                                setFieldValue("imageType", selectedValue)
                                // Reset the value of imageUrl and image when the image type changes
                                setFieldValue("imageUrl", "")
                                setFieldValue("imageFile", null)
                              }}
                            >
                              <option value="URL">{t("Image Url")}</option>
                              <option value="UPLOAD">
                                {t("Upload Image")}
                              </option>
                            </Field>
                            <TextError name="imageType" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            {/* IMAGE URL */}
                            {values.imageType === "URL" && (
                              <div className="form_field">
                                <label htmlFor="imageUrl">{t("URL")}</label>
                                <Field
                                  type="text"
                                  id="imageUrl"
                                  name="imageUrl"
                                  className={`form-control ${
                                    touched.imageUrl && errors.imageUrl
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name="imageUrl" />
                              </div>
                            )}
                            {/* UPLOAD IMAGE */}
                            {values.imageType === "UPLOAD" && (
                              <div className="form_field position-relative">
                                <label htmlFor="imageFile">
                                  {t("Upload Image")}
                                </label>
                                <TranslatedFileInput
                                  id="imageFile"
                                  name="imageFile"
                                  accept="image/jpeg, image/jpg, image/png, image/webp"
                                  invalid={
                                    !!(touched.imageFile && errors.imageFile)
                                  }
                                  onChange={e => {
                                    handleFileChange2(
                                      e,
                                      "imageFile",
                                      setFieldValue
                                    )
                                  }}
                                />
                                {isImageCompressing && (
                                  <Spinner
                                    color="primary"
                                    className="file_upload_btn"
                                  />
                                )}
                                <TextError name="imageFile" />
                              </div>
                            )}
                            {getImagePreviewSrc(mode, values) && (
                              <div className="mt-3">
                                <img
                                  src={getImagePreviewSrc(mode, values)}
                                  alt="Preview"
                                  className="img_preview"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="status">Status</label>
                            <Switch
                              isChecked={values.status}
                              onClickHandler={() => {
                                setFieldValue("status", !values.status)
                              }}
                            />
                          </div>
                        </div> */}
                        <div className="mt-3"></div>
                        <div className="col-12 d-flex justify-content-end">
                          <Button
                            type="button"
                            className="mx-2"
                            color="secondary"
                            onClick={() => navigate(-1)}
                          >
                            {t("Cancel")}
                          </Button>
                          <Button
                            type="submit"
                            color="success"
                            disabled={isLoading}
                            className="w_fit_content"
                          >
                            {mode === "add" ? t("Add") : t("Save")}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddIngredient
